// This is a generated file - DO NOT EDIT DIRECTLY

export const icons = {
  abv: ` &:before{ content: "\\f101"; } `,
  add: ` &:before{ content: "\\f102"; } `,
  'advanced-notes': ` &:before{ content: "\\f103"; } `,
  alcohol: ` &:before{ content: "\\f104"; } `,
  'alert-circle-filled': ` &:before{ content: "\\f105"; } `,
  'alert-circle': ` &:before{ content: "\\f106"; } `,
  'alert-triangle': ` &:before{ content: "\\f107"; } `,
  amex: ` &:before{ content: "\\f108"; } `,
  'app-subscription': ` &:before{ content: "\\f109"; } `,
  'apple-pay': ` &:before{ content: "\\f10a"; } `,
  armoa: ` &:before{ content: "\\f10b"; } `,
  'arrow-left': ` &:before{ content: "\\f10c"; } `,
  'award-winning': ` &:before{ content: "\\f10d"; } `,
  award: ` &:before{ content: "\\f10e"; } `,
  back: ` &:before{ content: "\\f10f"; } `,
  biodynamic: ` &:before{ content: "\\f110"; } `,
  'birthday-bonus': ` &:before{ content: "\\f111"; } `,
  'blend-type': ` &:before{ content: "\\f112"; } `,
  'bottle-glass': ` &:before{ content: "\\f113"; } `,
  bottle: ` &:before{ content: "\\f114"; } `,
  boxes: ` &:before{ content: "\\f115"; } `,
  'calendar-clock': ` &:before{ content: "\\f116"; } `,
  calendar: ` &:before{ content: "\\f117"; } `,
  camera: ` &:before{ content: "\\f118"; } `,
  'caps-lock': ` &:before{ content: "\\f119"; } `,
  cart: ` &:before{ content: "\\f11a"; } `,
  case: ` &:before{ content: "\\f11b"; } `,
  check: ` &:before{ content: "\\f11c"; } `,
  Checkbox: ` &:before{ content: "\\f11d"; } `,
  cheers: ` &:before{ content: "\\f11e"; } `,
  'chevron-down': ` &:before{ content: "\\f11f"; } `,
  'chevron-left': ` &:before{ content: "\\f120"; } `,
  'chevron-right': ` &:before{ content: "\\f121"; } `,
  'chevron-up': ` &:before{ content: "\\f122"; } `,
  chocolate: ` &:before{ content: "\\f123"; } `,
  'choice-check': ` &:before{ content: "\\f124"; } `,
  'choice-uncheck': ` &:before{ content: "\\f125"; } `,
  'circle-chevron-left': ` &:before{ content: "\\f126"; } `,
  'circle-chevron-right': ` &:before{ content: "\\f127"; } `,
  'clear-circle': ` &:before{ content: "\\f128"; } `,
  close: ` &:before{ content: "\\f129"; } `,
  'convenient-delivery': ` &:before{ content: "\\f12a"; } `,
  'cork-screw': ` &:before{ content: "\\f12b"; } `,
  coupons: ` &:before{ content: "\\f12c"; } `,
  'credit-card': ` &:before{ content: "\\f12d"; } `,
  'customer-services': ` &:before{ content: "\\f12e"; } `,
  customize: ` &:before{ content: "\\f12f"; } `,
  'customized-selections': ` &:before{ content: "\\f130"; } `,
  delete: ` &:before{ content: "\\f131"; } `,
  diamond: ` &:before{ content: "\\f132"; } `,
  discover: ` &:before{ content: "\\f133"; } `,
  'dot-menu': ` &:before{ content: "\\f134"; } `,
  'dots-menu': ` &:before{ content: "\\f135"; } `,
  droplet: ` &:before{ content: "\\f136"; } `,
  edit: ` &:before{ content: "\\f137"; } `,
  email: ` &:before{ content: "\\f138"; } `,
  'envelope-box': ` &:before{ content: "\\f139"; } `,
  envelope: ` &:before{ content: "\\f13a"; } `,
  expand: ` &:before{ content: "\\f13b"; } `,
  eye: ` &:before{ content: "\\f13c"; } `,
  facebook: ` &:before{ content: "\\f13d"; } `,
  'file-user': ` &:before{ content: "\\f13e"; } `,
  filter: ` &:before{ content: "\\f13f"; } `,
  flexibility: ` &:before{ content: "\\f140"; } `,
  'free-delivery': ` &:before{ content: "\\f141"; } `,
  gift: ` &:before{ content: "\\f142"; } `,
  glass: ` &:before{ content: "\\f143"; } `,
  glasses: ` &:before{ content: "\\f144"; } `,
  'google-pay': ` &:before{ content: "\\f145"; } `,
  grape: ` &:before{ content: "\\f146"; } `,
  'green-tick': ` &:before{ content: "\\f147"; } `,
  'hamburger-menu': ` &:before{ content: "\\f148"; } `,
  'hand-truck': ` &:before{ content: "\\f149"; } `,
  'heart-solid': ` &:before{ content: "\\f14a"; } `,
  heart: ` &:before{ content: "\\f14b"; } `,
  'help-circle': ` &:before{ content: "\\f14c"; } `,
  'hide-password': ` &:before{ content: "\\f14d"; } `,
  home: ` &:before{ content: "\\f14e"; } `,
  'homepage-customisation': ` &:before{ content: "\\f14f"; } `,
  'info-circle': ` &:before{ content: "\\f150"; } `,
  'information-circle': ` &:before{ content: "\\f151"; } `,
  instagram: ` &:before{ content: "\\f152"; } `,
  kosher: ` &:before{ content: "\\f153"; } `,
  'label-scanner': ` &:before{ content: "\\f154"; } `,
  'last-sold-bg': ` &:before{ content: "\\f155"; } `,
  'ligntning-solid': ` &:before{ content: "\\f156"; } `,
  'linked-in': ` &:before{ content: "\\f157"; } `,
  'live-chat': ` &:before{ content: "\\f158"; } `,
  location: ` &:before{ content: "\\f159"; } `,
  mastercard: ` &:before{ content: "\\f15a"; } `,
  menu: ` &:before{ content: "\\f15b"; } `,
  minus: ` &:before{ content: "\\f15c"; } `,
  'money-back-apac': ` &:before{ content: "\\f15d"; } `,
  'money-back-us': ` &:before{ content: "\\f15e"; } `,
  'money-back': ` &:before{ content: "\\f15f"; } `,
  mute: ` &:before{ content: "\\f160"; } `,
  'no-obligation': ` &:before{ content: "\\f161"; } `,
  'offset-carbon': ` &:before{ content: "\\f162"; } `,
  organic: ` &:before{ content: "\\f163"; } `,
  'packaging-pioneer': ` &:before{ content: "\\f164"; } `,
  'pad-lock-benefits': ` &:before{ content: "\\f165"; } `,
  padlock: ` &:before{ content: "\\f166"; } `,
  pause: ` &:before{ content: "\\f167"; } `,
  paypal: ` &:before{ content: "\\f168"; } `,
  'phone-arrow': ` &:before{ content: "\\f169"; } `,
  'phone-solid': ` &:before{ content: "\\f16a"; } `,
  phone: ` &:before{ content: "\\f16b"; } `,
  pioneer: ` &:before{ content: "\\f16c"; } `,
  placeholder: ` &:before{ content: "\\f16d"; } `,
  'play-video': ` &:before{ content: "\\f16e"; } `,
  play: ` &:before{ content: "\\f16f"; } `,
  print: ` &:before{ content: "\\f170"; } `,
  'question-circle': ` &:before{ content: "\\f171"; } `,
  'radio-selected': ` &:before{ content: "\\f172"; } `,
  radio: ` &:before{ content: "\\f173"; } `,
  'red-alert-circle-filled': ` &:before{ content: "\\f174"; } `,
  'restaurant-dishes': ` &:before{ content: "\\f175"; } `,
  rossette: ` &:before{ content: "\\f176"; } `,
  'sale-tag-benefits': ` &:before{ content: "\\f177"; } `,
  'sale-tag': ` &:before{ content: "\\f178"; } `,
  sale: ` &:before{ content: "\\f179"; } `,
  'satisfaction-guarantee': ` &:before{ content: "\\f17a"; } `,
  saving: ` &:before{ content: "\\f17b"; } `,
  savings: ` &:before{ content: "\\f17c"; } `,
  search: ` &:before{ content: "\\f17d"; } `,
  share: ` &:before{ content: "\\f17e"; } `,
  sort: ` &:before{ content: "\\f17f"; } `,
  'star-solid': ` &:before{ content: "\\f180"; } `,
  star: ` &:before{ content: "\\f181"; } `,
  'stwc-blog': ` &:before{ content: "\\f182"; } `,
  'subscribe-save': ` &:before{ content: "\\f183"; } `,
  sustainable: ` &:before{ content: "\\f184"; } `,
  target: ` &:before{ content: "\\f185"; } `,
  'thumbs-down-solid': ` &:before{ content: "\\f186"; } `,
  'thumbs-down': ` &:before{ content: "\\f187"; } `,
  'thumbs-up-solid': ` &:before{ content: "\\f188"; } `,
  'thumbs-up': ` &:before{ content: "\\f189"; } `,
  'tick-circle-solid': ` &:before{ content: "\\f18a"; } `,
  'tick-circle': ` &:before{ content: "\\f18b"; } `,
  ticket: ` &:before{ content: "\\f18c"; } `,
  trending: ` &:before{ content: "\\f18d"; } `,
  'truck-benefits': ` &:before{ content: "\\f18e"; } `,
  'truck-solid': ` &:before{ content: "\\f18f"; } `,
  truck: ` &:before{ content: "\\f190"; } `,
  trust: ` &:before{ content: "\\f191"; } `,
  twitter: ` &:before{ content: "\\f192"; } `,
  'unidentified-country': ` &:before{ content: "\\f193"; } `,
  units: ` &:before{ content: "\\f194"; } `,
  'unlimited-avr': ` &:before{ content: "\\f195"; } `,
  'unlimited-sale': ` &:before{ content: "\\f196"; } `,
  'unlimited-save': ` &:before{ content: "\\f197"; } `,
  'unlimited-stwc': ` &:before{ content: "\\f198"; } `,
  'unlimited-truck': ` &:before{ content: "\\f199"; } `,
  unlimited: ` &:before{ content: "\\f19a"; } `,
  unltCheckIcon: ` &:before{ content: "\\f19b"; } `,
  user: ` &:before{ content: "\\f19c"; } `,
  vegan: ` &:before{ content: "\\f19d"; } `,
  vegetarian: ` &:before{ content: "\\f19e"; } `,
  views: ` &:before{ content: "\\f19f"; } `,
  vinny: ` &:before{ content: "\\f1a0"; } `,
  visa: ` &:before{ content: "\\f1a1"; } `,
  warning: ` &:before{ content: "\\f1a2"; } `,
  'wine-colour': ` &:before{ content: "\\f1a3"; } `,
  'wine-glass': ` &:before{ content: "\\f1a4"; } `,
  world: ` &:before{ content: "\\f1a5"; } `,
  'x-twitter': ` &:before{ content: "\\f1a6"; } `,
  youtube: ` &:before{ content: "\\f1a7"; } `,
  zoom: ` &:before{ content: "\\f1a8"; } `,
};
